import React from "react";
import {
  MapPin,
  CircleGauge,
  ShieldCheck,
  Handshake,
  Truck,
  ChevronRight,
  ChevronLeft,
} from "lucide-react";

import { COMPANY_NAME } from "../../config/constants";
import Button from "../ui/Button";
import { useTranslation } from "../../context/TranslationContext";

import Image1 from "../../assets/image2.jpeg";

const Hero: React.FC = () => {
  const { t } = useTranslation();

  const featuresIconSize = "w-4 h-4";

  const features = [
    {
      title: t("hero.features.fastDelivery.title"),
      description: t("hero.features.fastDelivery.description"),
      icon: <CircleGauge className={`${featuresIconSize}`} />,
    },
    {
      title: t("hero.features.storage.title"),
      description: t("hero.features.storage.description"),
      icon: <ShieldCheck className={`${featuresIconSize}`} />,
    },
    {
      title: t("hero.features.partners.title"),
      description: t("hero.features.partners.description"),
      icon: <Handshake className={`${featuresIconSize}`} />,
    },
    {
      title: t("hero.features.experts.title"),
      description: t("hero.features.experts.description"),
      icon: <Truck className={`${featuresIconSize}`} />,
    },
  ];

  return (
    <div className="relative min-h-screen">
      {/* Content */}
      <div className="app-container flex md:flex-row flex-col gap-10 pt-20 pb-10">
        <div className="flex flex-col gap-6 justify-center md:w-1/2 z-10">
          <div>
            <div className="flex gap-2 md:gap-6 flex ml-auto flex-wrap">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="bg-cloud p-1 md:p-2 rounded-lg shadow-sm"
                >
                  <div className="text-neutral flex gap-2 items-center">
                    {feature.icon}
                    <h3 className="text-sm md:text-md font-semibold">
                      {feature.title}
                    </h3>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <h1 className="headline break-words hyphens-auto">
            {t("hero.tagline")}
          </h1>
          <div>
            <div className="w-full font-semibold text-lg flex flex-row items-center gap-2">
              <div className="w-fit text-nowrap">NDR Transport & Logistics</div>
              <div className="border-b border-black/20 w-full" />
            </div>
            <div className="w-full flex">
              <a href="#contact" className="ml-auto">
                <Button
                  variant="primary"
                  size="lg"
                  className="flex items-center px-5 md:px-10 "
                >
                  <ChevronRight className="hidden md:block" />
                  <ChevronRight />
                  <div className="px-2 md:px-5">{t("common.getInTouch")}</div>
                  <ChevronLeft />
                  <ChevronLeft className="hidden md:block" />
                </Button>
              </a>
            </div>
          </div>
        </div>
        <div className="md:w-1/2 rounded-2xl overflow-hidden">
          <img
            src={Image1}
            className="w-full h-full object-cover object-center"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
